import styled from "styled-components"

export default styled.span`
  background-color: ${props => props.color || "lightgrey"};
  border-radius: 15px;
  color: #fff;
  padding: 4px 15px;
  box-shadow: 0 5px 10px 0 rgba(180, 151, 90, 0.15);
`
